export const en = {
    campaign: 'Campaign',
    group: 'Group',
    'minus-phrases-per-group': 'Negative keywords in group',
    'not-specified': 'Not defined',
    region: 'Region'
};
